import { identity, pathOr, pick, pipe, prop } from 'ramda';
import { useUserSelector, useAppSelector } from 'js/store/hooks';
import parse from 'js/components/main/Cashier/parse';
import { getPaymentMethodAccounts, getPaymentMethodList } from './actions';
import { usePortletConfig, usePortletSelector } from 'js/components/system/Portlet';

export const useMethodSelector = (selector = identity) => usePortletSelector(
    pipe(prop('method'), selector)
);

export const fetch = ({ config, suggestDepositAmounts, enableVisaCheckout, tokenProvider }) => {
    const { paymentType } = config;
    const parseGpm = parse({ ...config, enableVisaCheckout, tokenProvider });

    return Promise.all([
            getPaymentMethodList({
                suggestions: suggestDepositAmounts,
                type: paymentType
            }),
            getPaymentMethodAccounts()
        ])
        .then(parseGpm);
};

export const useParams = () => {
    const quickDepositShowSuggestions = useAppSelector(prop('quickDepositShowSuggestions'));
    const { enableVisaCheckout, tokenProvider } = useUserSelector(pipe(
        pathOr({}, ['paymentsConfig']),
        pick(['enableVisaCheckout', 'tokenProvider'])
    ));

    // { paymentMethodsOrder, hideParentPaymentMethods }
    const config = usePortletConfig();
    const suggestDepositAmounts = config.suggestDepositAmounts ?? quickDepositShowSuggestions;

    return {
        config,
        suggestDepositAmounts,
        enableVisaCheckout,
        tokenProvider
    };
};
